import { sortArrayByProp } from "./util";
import extend from "../modules/extend";
import axios from "axios";
import capitalize from "../modules/capitalize";

export default class SelectFilter {
    constructor(...ops) {
        extend(
            this,
            {
                selector: "tabs__select"
            },
            ops
        );

        this.filterableList = document.getElementsByClassName("ctaList--filterable")[0];
        this.exclusive = this.filterableList ? this.filterableList.hasAttribute("data-exclusive-filter") : false;
        this.currentFilters = [];
        this.apiPath = "";
        this.init();
    }

    init() {
        this.setFilterFns();
        this.getAvailableCategories();

        if (this.filterableList && this.filterableList.classList.contains("ctaList--lazyFilterable")) {
            this.itemsPerPage = this.filterableList ? this.filterableList.getAttribute("data-items-per-page") : 0;
            this.filterEvent = new Event("filter");
            this.watchFilterable();
            this.awaitMax();
        }
    }

    watchFilterable() {
        // use MutationObserver to react to all additions/removals of listItems
        this.listObserver = new MutationObserver(() => this.updateVisible());

        this.listObserver.observe(this.filterableList, { attributes: false, childList: true, subtree: true });
    }

    setFilterFns() {
        let self = this;

        this.showItem = function(el) {
            el.classList.remove("hide");
        };

        this.hideItem = function(el) {
            el.classList.add("hide");
        };

        this.showHideEl = this.exclusive
            ? function(categoriesList, currentFilters, el) {
                  for (let i = 0; i < currentFilters.length; i++) {
                      let filter = currentFilters[i];
                      if (!categoriesList.includes(filter)) {
                          self.hideItem(el);
                          return;
                      }
                  }
                  self.showItem(el);
              }
            : function(categoriesList, currentFilters, el) {
                  for (let i = 0; i < currentFilters.length; i++) {
                      let filter = currentFilters[i];
                      if (categoriesList.includes(filter)) {
                          self.showItem(el);
                          return;
                      }
                  }
                  self.hideItem(el);
              };
    }

    executeQuery(path, params, callback) {
        axios.get(path, { params: params }).then(callback);
    }

    updateFilters() {
        this.currentFilters = [
            ...new Set(
                Array.from(document.getElementsByClassName("categorySelect"))
                    .map(d => this.getSelectValue(d))
                    .filter(d => d && !["Industry", "Capability", "Language", "Region", "--- Select Additional ---"].includes(d))
            )
        ];

        this.updateVisible();
    }

    resetFilters(parentEl) {
        let children = parentEl.querySelectorAll(".selectAdditional");

        children.forEach(childEl => {
            parentEl.removeChild(childEl);
        });

        this.updateFilters();
    }

    updateVisible() {
        let noResults = true;
        let listItems = this.filterableList ? this.filterableList.children : [];

        for (let i = 0; i < listItems.length; i++) {
            let el = listItems[i];
            let categories = el.getAttribute("data-categories");

            if (this.currentFilters.length == 0) {
                this.showItem(el);
            } else if (categories) {
                let categoriesList = categories.split(",");
                this.showHideEl(categoriesList, this.currentFilters, el);
            } else {
                this.hideItem(el);
            }

            if (!el.classList.contains("hide")) {
                noResults = false;
            }
        }

        /* assess whether No Results message is needed */
        if (noResults && this.listFull) {
            this.filterableList.classList.add("ctaList--noResults");
        } else {
            this.filterableList.classList.remove("ctaList--noResults");
        }
    }

    updateSelect(ops) {
        if (ops.optionsArray.length) {
            let optionsHTML = "";

            sortArrayByProp(ops.optionsArray, "displayName").forEach(function(option) {
                optionsHTML = optionsHTML + `<option value="${option.name}">${option.displayName || capitalize(option.name.replace("-", " "))}</option>`;
            });

            ops.el.innerHTML = ops.el.innerHTML + optionsHTML;

            this[ops.group + "Options"] = optionsHTML;

            this.watchSelect(ops.el);
        } else {
            ops.el.parentElement.style.display = "none"; // hide the form section when no options
        }
    }

    updateDropdownContent(availableCategories) {
        this.updateSelect({
            optionsArray: availableCategories.filter(d => d.path && d.path.includes("industries")),
            el: document.getElementsByClassName("select--industry")[0],
            group: "industry"
        });

        this.updateSelect({
            optionsArray: availableCategories.filter(d => d.path && d.path.includes("capabilities")),
            el: document.getElementsByClassName("select--industry")[0],
            group: "capability"
        });

        this.updateSelect({
            optionsArray: availableCategories.filter(d => d.path && d.path.includes("languages")),
            el: document.getElementsByClassName("select--language")[0],
            group: "language"
        });

        this.updateSelect({
            optionsArray: availableCategories.filter(d => d.path && d.path.includes("regions")),
            el: document.getElementsByClassName("select--region")[0],
            group: "region"
        });
    }

    makeDropdowns() {
        let industryDropdown = document.getElementsByClassName("select--industry")[0];
        let capabilityDropdown = document.getElementsByClassName("select--capability")[0];
        let languageDropdown = document.getElementsByClassName("select--language")[0];
        let regionDropdown = document.getElementsByClassName("select--region")[0];

        industryDropdown.innerHTML = `<option value="">${industryDropdown.getAttribute("data-view-all") || "View All"}</option>`;
        capabilityDropdown.innerHTML = `<option value="">${capabilityDropdown.getAttribute("data-view-all") || "View All"}</option>`;
        languageDropdown.innerHTML = `<option value="">${languageDropdown.getAttribute("data-view-all") || "View All"}</option>`;
        regionDropdown.innerHTML = `<option value="">${regionDropdown.getAttribute("data-view-all") || "View All"}</option>`;
    }

    getAvailableCategories() {
        let self = this;
        let availableCategories = document.querySelector("#data-available-categories");
        if (!availableCategories) return null;

        // set placeholders
        this.makeDropdowns();

        // get actually available
        this.executeQuery(
            availableCategories.getAttribute("data-url"),
            {
                returnAll: true,
                category: "all"
            },
            function(response) {
                if (response.data && response.data.data) {
                    let results = [
                        ...new Set(
                            response.data.data
                                .filter(d => d.categories)
                                .map(d => d.categories)
                                .flat()
                        )
                    ].map(d => {
                        let jsonReplace = d ? d.replace(/'/g, '"') : null;
                        let json = JSON.parse(jsonReplace);
                        return json;
                    });

                    self.updateDropdownContent(results);
                }
            }
        );
    }

    addSelect(type, parentEl) {
        let el = document.createElement("select");
        let optionsHTML = `<option value="" disabled selected>--- Select Additional ---</option>`;

        el.classList = `select--${type} categorySelect selectAdditional`;
        el.setAttribute("data-type", type);
        el.innerHTML = optionsHTML + this[type + "Options"];
        parentEl.appendChild(el);

        this.watchSelect(el);
    }

    watchSelect(el) {
        let self = this;

        el.addEventListener("change", function(e) {
            e.preventDefault();

            if (self.getSelectValue(el) == "") {
                // "View All" option
                el.classList.remove("touched");
                self.resetFilters(el.parentElement);
            } else {
                self.updateFilters();

                if (!el.classList.contains("touched")) {
                    self.addSelect(el.getAttribute("data-type"), el.parentElement);
                    el.classList.add("touched");
                }
            }

            // dispatch custom filter event to trigger more lazy-pagination as necessary
            if (!self.listFull && self.filterableList && self.filterableList.classList.contains("lazy-pagination")) {
                self.filterableList.dispatchEvent(self.filterEvent);
                self.reassessVisible();
            }
        });
    }

    reassessVisible(listItems = this.filterableList ? this.filterableList.children : []) {
        let visible = Array.from(listItems).filter(d => !d.classList.contains("hide"));
        if (!this.listFull && visible.length <= this.itemsPerPage) {
            this.filterableList.dispatchEvent(this.filterEvent);
            setTimeout(this.reassessVisible, 100);
        }
    }

    awaitMax() {
        let self = this;

        this.filterableList.addEventListener("atMax", function() {
            setTimeout(() => {
                // pause to allow final element filtering
                self.listFull = true;
                self.listObserver.disconnect();
            }, 500);
        });
    }

    getSelectValue(el) {
        return el.selectedIndex < 0 ? el : el.options[el.selectedIndex].value;
    }
}
